import { CtaDefinition } from '../../cta/cta.models';
import { AiChatInitialAction } from '../ai-chat.types';

/**
 * Maps a CTA to the chat launch action shared by every CTA surface (page,
 * popup, full-page): a static canned reply for static CTAs, otherwise a bot
 * prompt whose failure runs `onError` so the optimistic cooldown can be rolled
 * back and the suggestion reappears.
 */
export function ctaToInitialAction(
  cta: CtaDefinition,
  onError: () => void,
): AiChatInitialAction {
  if (cta.isStaticResponse && cta.staticResponseKey) {
    return { staticReplyKey: cta.staticResponseKey };
  }

  return {
    prompt: cta.prompt ?? undefined,
    onError,
  };
}
